import { Dispatch, FC, SetStateAction } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { deepPurple } from "@mui/material/colors";

import type { ListViewOption } from "./view-options";

const sxStyles = {
  deptSelector: {
    width: "13.75rem",
    background: "white",
  },
  input: {
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: deepPurple[800] + " !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: deepPurple[800],
    },
  },
};

const isSameBoard = (option: ListViewOption, value: ListViewOption) =>
  option.kind === value.kind &&
  option.id === value.id &&
  option.hospitalID === value.hospitalID;

interface DepartmentSelectorProps {
  options: ListViewOption[];
  // Always controlled: null until the selected board's option has loaded.
  value: ListViewOption | null;
  setSelectedDept: Dispatch<SetStateAction<Record<string, any>>>;
  handleUpdateDefaultDepartment: (string) => void;
}

const DepartmentSelector: FC<DepartmentSelectorProps> = ({
  options,
  value,
  setSelectedDept,
  handleUpdateDefaultDepartment,
}) => {
  const handleSelectDept = (event, option) => {
    if (option) {
      setSelectedDept(option);
      handleUpdateDefaultDepartment(option);
    }
  };

  return (
    <Autocomplete
      disablePortal
      options={options}
      value={value}
      isOptionEqualToValue={isSameBoard}
      sx={sxStyles.deptSelector}
      renderInput={(params) => (
        <TextField
          {...params}
          label="View"
          size="small"
          placeholder="Search by keyword"
          sx={sxStyles.input}
        />
      )}
      onChange={handleSelectDept}
    />
  );
};

export default DepartmentSelector;
